import React from 'react'
import Page from '../Page'
import MasterHeader from '../../Components/MasterHeader/MasterHeader'
import definition from './definition.json'
import { NavLink } from 'react-router-dom'

const SearchForm = (props) => {
    return (
        <div className="container" style={{ maxWidth: '700px' }}>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group" style={{ display: 'flex' }}>
                        <input defaultValue={props.term} onChange={props.onChange} className="form-control" id="search_paolo_stoppa_site" type="text" placeholder="Ricerca" />
                    </div>
                </div>
            </div>
        </div>
    )
}

const SearchResult = (props) => {

    const to = {
        pathname: props.result.page.link,
        search: '?term=' + props.term + "&inner=" + props.result.key
    }

    return (
        <div className="search_results">
            <div className="col-sm-6 text-right"><p dangerouslySetInnerHTML={{ __html: props.result.match }}></p></div>
            <div className="col-sm-6 text-left" ><p>{props.result.page.label}
                <NavLink to={to} style={{ paddingLeft: '30px', color: 'black' }}><i className="fas fa-search"></i></NavLink></p>
            </div>
        </div>
    )
}


class Search extends Page {

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate = (prevProps) => {
        return;
    };

    render() {

        return (
            <div>
                <MasterHeader master={definition.master}>
                    <SearchForm term={this.props.term} onChange={(e) => this.props.onChange(e.target.value)} />
                </MasterHeader>
                {
                    this.props.results &&
                    <section className="page-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h2 className="section-heading">Risultati</h2>
                                </div>
                            </div>
                            {this.props.results.map((r, k) =>
                                r.map((rr, t) => (
                                    <SearchResult key={t} result={rr} term={this.props.term} />
                                ))
                            )
                            }
                        </div>
                    </section>
                }
            </div>
        );
    }
}

export default Search;